import React from "react";
import { Helmet } from "react-helmet";

const SalesIntelScript = () => {
  return (
    <Helmet>
      <script
        charSet="utf-8"
        type="text/javascript"
        src="https://api-gateway.scriptintel.io/service/visitorintel/visitorTag/221764/script.js?apiKey=MjIxNzY0NDMyOWE4NDUtZDMxYy00MjEwLThkYzEtYTM5NzNlNTFjYjVj"
      ></script>
      {/* <script type="text/javascript">
        {`
          !function(e,r){
            try {
              if(e.vector)
                return void console.log("Vector snippet included more than once.");
              var t = {};
              t.q = t.q || [];
              for(var o=["load","identify","on"],n=function(e){
                return function(){
                  var r = Array.prototype.slice.call(arguments);
                  t.q.push([e, r])
                }
              }, c=0; c < o.length; c++){
                var a = o[c];
                t[a] = n(a)
              }
              if(e.vector = t, !t.loaded){
                var i = r.createElement("script");
                i.type = "text/javascript";
                i.async = true;
                i.src = "https://cdn.vector.co/pixel.js";
                var l = r.getElementsByTagName("script")[0];
                l.parentNode.insertBefore(i, l);
                t.loaded = true;
              }
            } catch(e) {
              console.error("Error loading Vector:", e);
            }
          }(window, document);
          vector.load("168ca7b3-7beb-4011-ac2e-17c70ac0db84");
        `}
      </script> */}
    </Helmet>
  );
};

export default SalesIntelScript;
